var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":"2000"},model:{value:(_vm.copySnackbar),callback:function ($$v) {_vm.copySnackbar=$$v},expression:"copySnackbar"}},[_vm._v(" "+_vm._s(_vm.copiedText)+" Copied to Clipboard ")])
}
var staticRenderFns = []

export { render, staticRenderFns }